<script>
import IMask from 'imask';
import InputMask from '../__components/InputMask.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputMask,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    options: {
      overwrite: true,
      autofix: true,
      mask: 'HH:MM',
      blocks: {
        HH: {
          mask: IMask.MaskedRange,
          placeholderChar: 'HH',
          from: 0,
          to: 23,
          maxLength: 2,
        },
        MM: {
          mask: IMask.MaskedRange,
          placeholderChar: 'MM',
          from: 0,
          to: 59,
          maxLength: 2,
        },
      },
    },
  }),
  methods: {
    blur(event) {
      this.$emit('blur', event);
      if (!this.value || this.value?.length !== 5) {
        setTimeout(() => {
          this.$emit('input', '');
        });
      }
    },
  },
};
</script>
<template>
  <InputMask
    :value="value || ''"
    :placeholder="placeholder"
    :disabled="disabled"
    :options="options"
    @focus="$emit('focus', $event)"
    @blur="blur"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
